import { MarkButton, Leaf, Element, BlockButton } from './components'
import { Editable, withReact, Slate } from 'slate-react'
import React, { useCallback, useMemo } from 'react'
import { withHistory } from 'slate-history'
import { createEditor } from 'slate'
import { toggleMark } from './utils'
import isHotkey from 'is-hotkey'
import './index.scss'

const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline'
}

const TextEditor = ({ value, disabled = false, setValue }) => {
  const renderElement = useCallback(props => <Element {...props} />, [])
  const renderLeaf = useCallback(props => <Leaf {...props} />, [])
  const editor = useMemo(() => withHistory(withReact(createEditor())), [])

  return (
    <div className='editor__container'>
      <Slate
        editor={editor}
        initialValue={value}
        onChange={_value => {
          setValue(_value)
        }}>
        <div className='editor__menu'>
          <MarkButton format='bold' icon='format_bold' />
          <MarkButton format='italic' icon='format_italic' />
          <MarkButton format='underline' icon='format_underlined' />
          <BlockButton format='heading-one' icon='looks_one' />
          <BlockButton format='heading-two' icon='looks_two' />
          <BlockButton format='block-quote' icon='format_quote' />
          <BlockButton format='numbered-list' icon='format_list_numbered' />
          <BlockButton format='bulleted-list' icon='format_list_bulleted' />
          <BlockButton format='left' icon='format_align_left' />
          <BlockButton format='center' icon='format_align_center' />
          <BlockButton format='right' icon='format_align_right' />
          <BlockButton format='justify' icon='format_align_justify' />
        </div>
        <Editable
          spellCheck
          disabled={disabled}
          className='editor'
          renderLeaf={renderLeaf}
          renderElement={renderElement}
          onKeyDown={event => {
            for (const hotkey in HOTKEYS) {
              if (isHotkey(hotkey, event)) {
                event.preventDefault()
                const mark = HOTKEYS[hotkey]
                toggleMark(editor, mark)
              }
            }
          }}
        />
      </Slate>
    </div>
  )
}

export default TextEditor